

// import { useRef, useState, useEffect } from 'react';
// import './HomeVideo.css';

// const HomeVideo = () => {
//   const videoRef = useRef();
//   const [isPlaying, setIsPlaying] = useState(false);

//   useEffect(() => {
//     const handleInteraction = () => {
//       videoRef.current.play();
//       setIsPlaying(true);
//       document.removeEventListener('click', handleInteraction);
//     };

//     document.addEventListener('click', handleInteraction);

//     return () => {
//       document.removeEventListener('click', handleInteraction);
//     };
//   }, []);

//   const handlePlay = () => {
//     if (videoRef.current.paused) {
//       videoRef.current.play();
//       setIsPlaying(true);
//     } else {
//       videoRef.current.pause();
//       setIsPlaying(false);
//     }
//   };

//   return (
//     <div className='vid_container'>
//       <div className="grid-btn vid_btn_div">
//         <button className="vid_btn" onClick={handlePlay}>
//           {isPlaying ? 'Pause video' : 'Play video'}
//         </button>
//       </div>
//       <video className="home_video" height="240" ref={videoRef}>
//         <source src="/assets/crest_video.mp4" />
//       </video>  
//       <video className=" h_mobile" ref={videoRef}>
//         <source src="/assets/video_mobile.mp4" />
//       </video>  
//     </div>
//   );
// };

// export default HomeVideo;

import { useRef, useState, useEffect } from 'react';
import './HomeVideo.css';

const HomeVideo = () => {
  const homeVideoRef = useRef();
  const mobileVideoRef = useRef();
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const handleInteraction = () => {
      homeVideoRef.current.play();
      mobileVideoRef.current.play();
      setIsPlaying(true);
      document.removeEventListener('click', handleInteraction);
    };

    document.addEventListener('click', handleInteraction);

    return () => {
      document.removeEventListener('click', handleInteraction);
    };
  }, []);

  const handlePlay = () => {
    if (homeVideoRef.current.paused) {
      homeVideoRef.current.play();
      mobileVideoRef.current.play();
      setIsPlaying(true);
    } else {
      homeVideoRef.current.pause();
      mobileVideoRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className='vid_container'>
      <div className="grid-btn vid_btn_div">
        <button className="vid_btn" onClick={handlePlay}>
          {isPlaying ? 'Pause video' : 'Play video'}
        </button>
      </div>
      <video className="home_video" height="240" ref={homeVideoRef}>
        <source src="/assets/crest_video.mp4" />
      </video>  
      <video className="h_mobile" ref={mobileVideoRef}>
        <source src="/assets/video_mobile.mp4" />
      </video>  
    </div>
  );
};

export default HomeVideo;
